import React from 'react'
import {useWidgetState} from '../../../hooks/state-provider'
import {getEvents} from '../../../selectors/events'
import {DesktopItem} from '../item'

export const FeaturedList = () => {
  const [featuredEvent] = useWidgetState(getEvents)

  return <DesktopItem event={featuredEvent} />
}
